const TIMEOUT_CODES = [-604102, 87015]

const SENSITIVE_CODE = 87014

const MAX_ERR_COUNT = 3

const SUCCESS_CODE = 0

const msgCheck = (content, options = { loading: true }) => {
    try {
        if (options.loading) {
            wx.showLoading({
                title: ''
            })
        }
        return wx.cloud
            .init()
            .then(() => {
                return wx.cloud.callFunction({
                    name: 'validityCheck',
                    data: {
                        content
                    }
                })
            })
            .then((res) => {
                console.error('cloud check error', res)
                if (options.loading) {
                    wx.hideLoading()
                }
                const { errCode } = res.result
                if (errCode === SENSITIVE_CODE) {
                    wx.showToast({
                        title: '内容含有敏感信息',
                        icon: 'none'
                    })
                } else if (TIMEOUT_CODES.indexOf(errCode) > -1 && msgCheck.error_count < MAX_ERR_COUNT) {
                    msgCheck.error_count++
                    return msgCheck(content, options)
                } else if (errCode != SUCCESS_CODE) {
                    const is_cloud_err = msgCheck.error_count >= MAX_ERR_COUNT
                    if (is_cloud_err) {
                        msgCheck.error_count = 0
                        return SUCCESS_CODE
                    }
                }
                return errCode
            })
            .catch((err) => {
                console.error('msgCheck error', err)
                if (options.loading) {
                    wx.hideLoading()
                }
                wx.showToast({
                    title: '网络出问题啦，请重试',
                    icon: 'none'
                })
                return 500
            })
    } catch (err) {
        return SUCCESS_CODE
    }
}

msgCheck.error_count = 0

const imgCheck = (value) => {
    wx.cloud.init()
    return wx.cloud
        .callFunction({
            // 云函数名称
            name: 'imgCheck',
            // 传给云函数的参数
            data: {
                value
            }
        })
        .then((res) => {
            console.error(res)
            if (res.result.errCode !== SUCCESS_CODE) {
                if (TIMEOUT_CODES.indexOf(res.result.errCode) > -1 && imgCheck.error_count < MAX_ERR_COUNT) {
                    console.error(res.result)
                    imgCheck.error_count++
                    return imgCheck(value)
                } else {
                    const is_cloud_err = imgCheck.error_count >= MAX_ERR_COUNT
                    imgCheck.error_count = 0
                    if (is_cloud_err) {
                        return SUCCESS_CODE
                    }
                    let content = '内容含有敏感信息'
                    if (res.result.errCode == 413) {
                        content = '上传图片不能超过1M'
                    }
                    wx.showModal({
                        title: '提示',
                        content,
                        showCancel: false
                    })
                }
            }
            return res.result.errCode
        })
        .catch((err) => {
            console.error('cloud error', err)
            wx.hideLoading()
            wx.showToast({
                title: '网络出问题啦，请重试',
                icon: 'none'
            })
            return 500
        })
}
imgCheck.error_count = 0

module.exports = {
    msgCheck,
    imgCheck
}
